/**
 * Forgot Password Replacer Model
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var BaseModel = require('common/base.model');
    var languageUtil = require('util/language.util');
    var config = require('config');
    var user = require('user');
    var core = require('core');
    var server = require('server');
    var pas = require('util/pas.util');
    var RecoveryTypes = require('replacers/parx-theme/forgotpassword/recovery-types');

    module.exports = BaseModel.extend({

        defaults: {
            recoveryType: null,
            recoverySessionToken: null,
            userName: null,
            email: null
        },

        initialize: function() {
            this.set('recoveryType', config.get('detailsRecovery')?.isRequiredVerificationEnable
                ? RecoveryTypes.BY_VERIFICATION_QUESTION
                : RecoveryTypes.BY_EMAIL);
        },

        /**
         * Initial user data submit handler, called from view
         * @param data
         * @returns {*}
         */
        forgotPasswordAction: function(data) {
            data.passwordRecoveryDestinationLink = window.location.origin + window.location.pathname;

            if (config.get('isUsernameInUppercase')) {
                data.username = data.username.toUpperCase();
            }

            return this.get('recoveryType') === RecoveryTypes.BY_VERIFICATION_QUESTION
                ? this.startOnlineVerification(data)
                : this.forgotPasswordDefaultRequest(data);
        },

        /**
         * Initialize online password reset verification process
         * @param formData
         */
        startOnlineVerification: function(formData) {
            var result = $.Deferred();

            server.send({
                    ID: 35535,
                    responses: [35536, 35537],
                    description: 'Start online forgot password session request',
                    casinoName: config.get('casinoName'),
                    birthDate: this.formatDateForRequest(formData),
                    email: formData.email,
                    userName: formData.username || '',
                    passwordRecoveryDestinationLink: formData.passwordRecoveryDestinationLink,
                    ...config.get('detailsRecovery')?.enableSmsNotifications && { notificationChannels: 'email,SMS' }
                })
                .done(function(response) {
                    this.set({
                        userName: formData.username,
                        email: formData.email,
                        recoverySessionToken: response.data.sessionToken
                    });

                    result.resolve(response.data);
                }.bind(this))
                .fail(result.reject);

            return result.promise();
        },

        /**
         * Default PAS restore password request
         * @param formData
         * @returns {*}
         * @private
         */
        forgotPasswordDefaultRequest: function(formData) {
            return user.forgotPassword({
                    userName: formData.username || '',
                    email: formData.email,
                    birthDate: this.formatDateForRequest(formData),
                    passwordRecoveryDestinationLink: formData.passwordRecoveryDestinationLink,
                    ...config.get('detailsRecovery')?.enableSmsNotifications && { notificationChannels: 'email,SMS' }
                })
                .done(core.trigger.bind(core, 'forgotPassword:success'))
                .fail(core.trigger.bind(core, 'forgotPassword:fail'));
        },

        formatDateForRequest: function(formData) {
            return formData.year + '-' + formData.month + '-' + formData.day;
        },

        /**
         * Sends online verification request with verification answer
         * @param formData
         * @returns {*}
         */
        sendVerificationAnswer: function(formData) {
            return server.send(
                _.extend(this.getOnlineVerificationBaseParams(), {
                    verificationAnswer: formData.verificationAnswer
                })
            );
        },

        /**
         * Sends online verification request with new password
         * @param formData
         * @returns {*}
         */
        sendNewPassword: function(formData) {
            return server.send(
                _.extend(this.getOnlineVerificationBaseParams(), {
                    newPassword: formData.password
                })
            );
        },

        getOnlineVerificationBaseParams: function() {
            return {
                ID: 35538,
                responses: [35539, 35540],
                description: 'Validate online forgot password session request',
                casinoName: config.get('casinoName'),
                sessionToken: this.get('recoverySessionToken'),
                email: this.get('email'),
                userName: this.get('userName')
            };
        },

        forgotPassByTokenRequest: function() {
            const fpActionToken = this.get('fpActionToken');
            const state = $.Deferred();
            const languageCode = user.get('unsupportedLang')
                ? config.get('defaultLocale')
                : user.get('lang');

            pas.forgotPassToken({
                    fpActionToken: fpActionToken,
                    languageCode: languageUtil.convertToIMS(languageCode)
                })
                .done((pasResponse) => {
                    const successResponse = _.propertyOf(pasResponse)([
                        'data',
                        'sessionValidationData',
                        'SessionValidationByPasswordChangeData',
                        0
                    ]);
                    if (successResponse) {
                        state.resolve(pasResponse);
                    } else {
                        state.reject(pasResponse);
                    }
                })
                .fail(pasResponse => state.reject(pasResponse));

            return state.promise();
        }
    });
});
